import I18n from 'I18n';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
const showSuccessAlert = (titleText, message) => {
  FloatingAlertStore.addAlert({
    message,
    titleText,
    type: 'success'
  });
};
const showErrorAlert = (titleText, message) => {
  FloatingAlertStore.addAlert({
    message,
    titleText,
    type: 'danger'
  });
};
const showColumnsModalSuccessAlert = (messageKey, count) => {
  if (count === undefined) {
    showSuccessAlert(I18n.text('defaultColumnsAlert.success.title'), I18n.text(`defaultColumnsAlert.success.${messageKey}`));
    return;
  }
  showSuccessAlert(I18n.text('defaultColumnsAlert.success.title'), I18n.text(`defaultColumnsAlert.success.${messageKey}`, {
    count
  }));
};
export const showAllColumnsSavedAlert = () => {
  showColumnsModalSuccessAlert('allColumnsSaved');
};
export const showColumnsMaintainedAlert = count => {
  showColumnsModalSuccessAlert('columnsMaintained', count);
};
export const showColumnsOverriddenAlert = count => {
  showColumnsModalSuccessAlert('columnsOverridden', count);
};
export const showSaveDefaultColumnsFailureAlert = () => {
  showErrorAlert(I18n.text('defaultColumnsAlert.error.title'), I18n.text('defaultColumnsAlert.error.defaultColumnSaveFail'));
};
export const showOverrideColumnsFailureAlert = () => {
  showErrorAlert(I18n.text('defaultColumnsAlert.error.title'), I18n.text('defaultColumnsAlert.error.overrideColumnsFailure'));
};
export const showDeleteSubmissionSuccessAlert = () => {
  showSuccessAlert(I18n.text('deleteSubmissionModal.resultBanner.successTitle'), I18n.text('deleteSubmissionModal.resultBanner.successMessage'));
};
export const showDeleteSubmissionFailureAlert = () => {
  showErrorAlert(I18n.text('deleteSubmissionModal.resultBanner.errorTitle'), I18n.text('deleteSubmissionModal.resultBanner.errorMessage'));
};